const tableLayout = {
  name: "table-layout",
  path: "/table-layout",
  title: "table-layout",
  description: "Utilities for controlling the table layout algorithm.",
  value: {
    'table-layout': {
      'table-auto': 'auto',
      'table-fixed': 'fixed',
    },
  },
  exampleData: [
    {
      example: {
        code: `<table class="table-auto w-full">
  <thead>
    <tr>
      <th class="border border-color-gray-300 px-4 py-2">Header 1</th>
      <th class="border border-color-gray-300 px-4 py-2">Header 2</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="border border-color-gray-300 px-4 py-2">A</td>
      <td class="border border-color-gray-300 px-4 py-2">B</td>
    </tr>
    <tr>
      <td class="border border-color-gray-300 px-4 py-2">C</td>
      <td class="border border-color-gray-300 px-4 py-2">D</td>
    </tr>
  </tbody>
</table>
<table class="table-fixed w-full mt-6">
  <thead>
    <tr>
      <th class="border border-color-gray-300 px-4 py-2 w-1/2">Header 1</th>
      <th class="border border-color-gray-300 px-4 py-2 w-1/2">Header 2</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="border border-color-gray-300 px-4 py-2">A</td>
      <td class="border border-color-gray-300 px-4 py-2">B</td>
    </tr>
    <tr>
      <td class="border border-color-gray-300 px-4 py-2">C</td>
      <td class="border border-color-gray-300 px-4 py-2">D</td>
    </tr>
  </tbody>
</table>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">table-auto</code> utility to automatically size table columns to fit the contents of its cells.  <code class="text-color-gray-800 dark:text-color-white font-semibold">table-fixed</code> utility to ignore the content of the table cells and use fixed widths for each column:
      </p>
      <div class="flex flex-col">
        <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">table-auto</p>
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th class="border border-color-gray-300 px-4 py-2">Header 1</th>
              <th class="border border-color-gray-300 px-4 py-2">Header 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-color-gray-300 px-4 py-2">The Sliding Mr. Bones (Next Stop, Pottersville)</td>
              <td class="border border-color-gray-300 px-4 py-2">Malcolm Lockyer</td>
            </tr>
            <tr>
              <td class="border border-color-gray-300 px-4 py-2">Witchy Woman</td>
              <td class="border border-color-gray-300 px-4 py-2">The Eagles</td>
            </tr>
          </tbody>
        </table>
        <p class="mb-2 mt-8 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">table-fixed</p>
        <table class="table-fixed w-full">
          <thead>
            <tr>
              <th class="border border-color-gray-300 px-4 py-2">Header 1</th>
              <th class="border border-color-gray-300 px-4 py-2">Header 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-color-gray-300 px-4 py-2">The Sliding Mr. Bones (Next Stop, Pottersville)</td>
              <td class="border border-color-gray-300 px-4 py-2">Malcolm Lockyer</td>
            </tr>
            <tr>
              <td class="border border-color-gray-300 px-4 py-2">Witchy Woman</td>
              <td class="border border-color-gray-300 px-4 py-2">The Eagles</td>
            </tr>
          </tbody>
        </table>
      </div>
      `
    }
  ]
};

export default tableLayout;
<div className="table-auto table-fixed"></div>